import { Pipe, PipeTransform } from '@angular/core';

import { Company } from '@models/company';
import { TaxRegime } from '@models/tax-regime';
import { CondensedTaxRegimeLabelPipe } from '@shared-pipes/condensed-tax-regime-label/condensed-tax-regime-label.pipe';

@Pipe({
  name: 'companyInfosLabel',
  standalone: true
})
export class CompanyInfosLabelPipe implements PipeTransform {
  readonly condensedTaxRegimeLabelPipe = new CondensedTaxRegimeLabelPipe();

  transform(company: Company, taxRegimes?: TaxRegime[], additionalInfo?: string): string {
    const creationInProgress = company?.creationRequestClosed === false ? 'En cours de création' : '';
    const legalForm = company?.legalForm ? company.legalForm : '';
    const reference = company?.reference ? `N° ${company.reference}` : '';
    const taxRegime =
      company?.taxRegime && taxRegimes
        ? this.condensedTaxRegimeLabelPipe.transform(company?.taxRegime, taxRegimes)
        : '';

    const companyInfos: string[] = [];

    if (creationInProgress) {
      companyInfos.push(creationInProgress);
    }

    if (legalForm) {
      companyInfos.push(legalForm);
    }

    if (reference) {
      companyInfos.push(reference);
    }

    if (taxRegime) {
      companyInfos.push(taxRegime);
    }

    if (additionalInfo) {
      companyInfos.push(additionalInfo);
    }

    return companyInfos.join(' • ');
  }
}
